import { render, staticRenderFns } from "./category-main.vue?vue&type=template&id=5576e22e&"
import script from "./category-main.vue?vue&type=script&lang=js&"
export * from "./category-main.vue?vue&type=script&lang=js&"
import style0 from "./category-main.vue?vue&type=style&index=0&id=5576e22e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports